import { Text } from '@chakra-ui/react'
import React from 'react'

import { FilterOption, FilterOptionWrapper } from './SnippetSettingsStyles'

interface FilterMenuProps {
  options: {
    label: string
    value: string
    default?: boolean
    disabled?: boolean
  }[]
  onChange: (value: string) => void
  selectedFilter: string
  ariaLabel?: string
}

const FilterMenu = ({
  options,
  onChange,
  selectedFilter,
  ariaLabel,
}: FilterMenuProps) => {
  return (
    <FilterOptionWrapper role="group" aria-label={ariaLabel}>
      {options.map(({ value, label }) => {
        const isSelected = selectedFilter === value
        return (
          <FilterOption
            aria-pressed={isSelected}
            key={value}
            onClick={() => onChange(value)}
            isSelected={isSelected}
          >
            <Text
              as="span"
              fontSize="sm"
              fontWeight={isSelected ? 'bold' : 'normal'}
            >
              {label}
            </Text>
          </FilterOption>
        )
      })}
    </FilterOptionWrapper>
  )
}

export default FilterMenu
